import React, { useEffect, useState, useContext } from 'react';

import '../Environments/WizardSteps/arrowBlockStyles.scss';

import { OidcRoutesContext } from '../../../contexts';

import { useToastAction } from '../../../hooks/useToastAction.js';
import { useSystemInformation } from '../../../hooks/useSystemInformation';

import * as TemplateApi from "../../../api/interactTemplateEnvironment.js";
import { getAll } from "../../../api/interactEnvironment";

import { Label as CmpLabel, labelGetIcons } from "../../../components/Label/index.js";
import { TwPage } from "../../../components/TailwindPage/index.js";
import { TwTable } from "../../../components/TailwindTable/index.js";


export default function ExtrasHubClients() {
  const loadAction = useToastAction();

  const [updatedTime, setUpdatedTime] = useState(Date.now());
  const [timeDiff, setTimeDiff] = useState(0);
  const [isRunning, setIsRunning] = useState(false);

  const oidcRoutesContext = useContext(OidcRoutesContext);
  const { hubClients, setHubClients } = useSystemInformation();

  const [loadingBaseData, setLoadingBaseData] = useState(true);
  const [loadingSrvData, setLoadingSrvData] = useState(true);

  const [hubClientStatus, setHubClientStatus] = useState(null);
  const [hubClientLookup, setHubClientLookup] = useState([]);

  const [interactEnvironments, setInteractEnvironments] = useState(null);
  const [unmappedServers, setUnmappedServers] = useState(null);

  const loadBaseData = async () => {
    loadAction.execute(async () => {
      console.log("ExtrasHubClients", "loadBaseData");

      setLoadingBaseData(false);

      const [srvEnvironments] = await Promise.all([getAll()]);
      setInteractEnvironments(srvEnvironments);
    }, "Failed to load (ExtrasSandbox)")
  }

  useEffect(() => {
    loadBaseData();

    }, []);

  useEffect(() => {
    let timerId;
    if (isRunning) {
      // Start the interval only if it's running and time remains
      timerId = setInterval(() => {
        setTimeDiff((prev) => prev + 1);
      }, 1000);
    }

    // Cleanup: this runs before the next effect or on unmount
    return () => clearInterval(timerId);
  }, [isRunning, timeDiff]); // Re-run effect when status or time changes

  const handleReset = () => {
    setIsRunning(false);
    setTimeDiff(0);
    setIsRunning(true);
  };

  useEffect(() => {
    handleReset();
  }, [updatedTime]);

  useEffect(async () => {
    console.log("ExtrasHubClients", "useEffect[hubClients]", "hubClients", hubClients);
    if (!!hubClients && !!hubClients.clients)
    {
      setUpdatedTime(Date.now());

      const lookup = hubClientLookup || [];
      var statuses = [];
      await Promise.all(hubClients.clients.map(async (client) => {
        var status = { id: client.connectionId };
        if (client.groupId === oidcRoutesContext?.customerInfo?.customerId)
        {
          try
          {
            var tplEnvironment = lookup.find(x => x.id === client.templateId);
            if (!tplEnvironment)
            {
              tplEnvironment = await TemplateApi.getInteractTemplateEnvironment(client.templateId);
              lookup.push({id: client.templateId, data: tplEnvironment});
            }
            status.tplEnvironment = tplEnvironment;
            var tplServer = lookup.find(x => x.id === client.serverId);
            if (!tplServer && tplEnvironment)
            {
              tplServer = tplEnvironment.servers.find(s => s.serverId === client.serverId);
              lookup.push({id: client.serverId, data: lookup});
            }
            status.tplServer = tplServer;
            status.tplIdOk = !!tplEnvironment;
            status.srvIdOk = !!tplServer;
            status.srvNameOk = tplServer?.name === client.machineName || false;

            statuses.push(status);

            console.log("ExtrasHubClients", "useEffect[hubClients]", "client", client, "status", status);
          } catch (ex) {
            console.log("ExtrasHubClients", "useEffect[hubClients]", "client", client, "ex", ex);
          }
        } else {
          console.log("ExtrasHubClients", "useEffect[hubClients]", "client", client);
        }
      }));

      console.log("ExtrasHubClients", "useEffect[hubClients]", "lookup", lookup, "statuses", statuses);
      setHubClientLookup(lookup);
      setHubClientStatus(statuses);
    }
  }, [hubClients]);

  useEffect(async () => {
      const unmappedSrvData = getUnmappedServers();
      setUnmappedServers(unmappedSrvData);
  }, [hubClientStatus]);

  useEffect(async () => {
    console.log("ExtrasHubClients", "useEffect[interactEnvironments]", "interactEnvironments", interactEnvironments);
    if (!!interactEnvironments && !!hubClientLookup)
    {
      const unmappedSrvData = getUnmappedServers();
      setUnmappedServers(unmappedSrvData);
      setLoadingSrvData(false);
    }
  }, [interactEnvironments, hubClientLookup]);

  const getUnmappedServers = () => {
    const unmappedSrvData = [];
    const lookup = hubClientLookup || [];
    const clients = hubClients?.clients || [];
    //console.log("ExtrasHubClients", "getUnmappedServers", "interactEnvironments", interactEnvironments, "clients", clients, "lookup", lookup);
    Object.keys(interactEnvironments || []).map(envGrp => {
      interactEnvironments[envGrp].map(env => {
        if (env.template.id.slice(0, 3) !== "VG|")  // Don't check virtual groups
        {
          const servers = env.template.servers;
          //console.log("ExtrasHubClients", "getUnmappedServers", "envGrp", envGrp, "env", env, "servers", servers);
          servers.map(srv => 
          {
            if (srv.enabled) {  // Only check enabled servers
              var tplServer = lookup.find(x => x.id === srv.serverId);
              if (!tplServer || !clients.find(c => c.serverId === srv.serverId))
              {
                unmappedSrvData.push(
                  {
                    envGrpId: envGrp,
                    tpl: env.template,
                    srv: srv
                  }
                );
              }
            }
          });
        }
      });
    });

    //console.log("ExtrasHubClients", "getUnmappedServers", "unmappedSrvData", unmappedSrvData);
    return unmappedSrvData;
  }

  const getVerificationIcon = (type) =>
  {
    switch (type)
    {
      case CmpLabel.types.success:
        return (<div className='w-6 text-text-green-600 dark:text-green-400'>
          { labelGetIcons(CmpLabel.types.success) }
        </div>);
      case CmpLabel.types.error:
        return (<div className='w-6 text-text-red-600 dark:text-red-400'>
          { labelGetIcons(CmpLabel.types.error) }
        </div>);
      case CmpLabel.types.warn:
        return (<div className='w-6 text-text-yellow-600 dark:text-yellow-400'>
          { labelGetIcons(CmpLabel.types.warn) }
        </div>);
      default:
        return (<div className='w-6 text-text-gray-600 dark:text-gray-400'>
          { labelGetIcons(CmpLabel.types.info) }
        </div>);
    }
  }

  const getDataOwnerVerificationIcon = (dataOwner, registeredClientId) =>
  {
      if (dataOwner)
      {
        if (dataOwner.connectionId === registeredClientId)
          return getVerificationIcon(CmpLabel.types.success);
        else
          return getVerificationIcon(CmpLabel.types.error);
      }
      return getVerificationIcon(CmpLabel.types.info);
  };

  const getClientDataVerificationIcon = (client, propName) =>
  {
    if (!hubClientStatus)
      return getVerificationIcon(CmpLabel.types.info);
    if (hubClientStatus)
    {
      const cs = hubClientStatus.find(x => x.id === client.connectionId);
      //console.log("ExtrasHubClients", "getClientDataVerificationIcon", "cs", cs);
      if (cs)
      {
        var valid = cs[propName];
        //console.log("ExtrasHubClients", "getClientDataVerificationIcon", "propName", propName, "valid", valid);
        if (valid)
          return getVerificationIcon(CmpLabel.types.success);
        else
          return getVerificationIcon(CmpLabel.types.error);
      }
      return getVerificationIcon(CmpLabel.types.warn);
    }
  };

  const truncateString = (str, num) => {
    if (str.length <= num) {
      return str;
    }
    return str.slice(0, num) + '...';
  };


  const renderClientList = (title, clients) => {
    //console.log("ExtrasHubClients", "renderClientList", "title", title, "clients", clients);

    return (
      <>
        <div className='flex flex-row mt-10 text-black dark:text-gray-200'>
          <h3 className="font-semibold leading-6 text-2xl flex">
            {title}
          </h3>
          <p className='mt-1 ml-2 text-sm'>&nbsp;({clients?.length || 0})</p>
        </div>
        <TwTable additionalClass='mt-6'>
          <TwTable.Head>
            <TwTable.Header additionalClass={'uppercase sm:pl-6'}>
              Connection Id
            </TwTable.Header>
            <TwTable.Header additionalClass={'uppercase sm:pl-6'}>
              Server Name 
            </TwTable.Header>
            <TwTable.Header additionalClass={'uppercase sm:pl-6'}>
              Company
            </TwTable.Header>
            <TwTable.Header additionalClass={'uppercase sm:pl-6'}>
              Template Environment
            </TwTable.Header>
            <TwTable.Header additionalClass={'uppercase sm:pl-6'}>
              Server
            </TwTable.Header>
          </TwTable.Head>
          <TwTable.Body>
            { clients && clients.map((client) => (
              <TwTable.BodyRow key={client.connectionId}>
                <TwTable.BodyCol additionalClass={'font-medium'}>
                  {client.connectionId}
                </TwTable.BodyCol>
                <TwTable.BodyCol>
                  <div className='flex flex-row gap-1'>
                    {client.machineName}
                    {getClientDataVerificationIcon(client, "srvNameOk")}
                  </div>
                </TwTable.BodyCol>
                <TwTable.BodyCol>
                  {client.groupId}
                </TwTable.BodyCol>
                <TwTable.BodyCol>
                  <div className='flex flex-row gap-1'>
                    {client.templateId}
                    {getClientDataVerificationIcon(client, "tplIdOk")}
                  </div>
                </TwTable.BodyCol>
                <TwTable.BodyCol>
                  <div className='flex flex-row gap-1'>
                    {client.serverId}
                    {getClientDataVerificationIcon(client, "srvIdOk")}
                  </div>
                </TwTable.BodyCol>
              </TwTable.BodyRow>
            ))}
          </TwTable.Body>
        </TwTable>      
      </>
    );
  };
  
  return (
    <>
      <TwPage>
        <TwPage.Header>
          <TwPage.Header.Hdr.Fixed 
            title="Hub Clients" 
          />
        </TwPage.Header>

        <CmpLabel type={CmpLabel.types.warn} additionalClass="mb-8">
          <p className="font-bold">
              This page is intended as a Metaforce administration page and should not be used by others.
          </p>
        </CmpLabel>

        {loadingBaseData && (
          <div className='flex flex-wrap'>
            <CmpLabel text={"Loading hub clients..."}  type={CmpLabel.types.loader} additionalClass='font-bold w-full' />
          </div>
        )}

        {hubClients && (
          <>
            <div className='flex flex-col mb-6'>
              <div className='flex flex-row'>
                <CmpLabel text={"Time since update:"} />
                <CmpLabel additionalClass='ml-2 font-bold'>
                  {`${Math.floor(timeDiff / 60)}`.padStart(2, 0)}:{`${Math.floor((timeDiff % 60) )}`.padStart(2, 0)}
                </CmpLabel>
              </div>
              <CmpLabel text={"(Updates every 60 seconds)"} textClass='text-xs' additionalClass='italic'/>
            </div>

            { hubClients.dataOwner && (
              <>
                <h3 className="font-semibold leading-6 text-2xl mt-1 flex text-black dark:text-gray-200">
                  Data owner
                </h3>
                <TwTable additionalClass='mt-6'>
                  <TwTable.Head>
                    <TwTable.Header additionalClass={'uppercase sm:pl-6'}>
                      Connection Id
                    </TwTable.Header>
                    <TwTable.Header additionalClass={'uppercase sm:pl-6'}>
                      Identifier 
                    </TwTable.Header>
                  </TwTable.Head>
                  <TwTable.Body>
                      <TwTable.BodyRow key={'dataOwner1'}>
                        <TwTable.BodyCol additionalClass={'font-medium'}>
                          <div className='flex flex-row gap-1'>
                            {hubClients.dataOwner.connectionId}
                            {getDataOwnerVerificationIcon(hubClients.dataOwner, hubClients.registeredConnectionId)}
                          </div>
                        </TwTable.BodyCol>
                        <TwTable.BodyCol>
                          {hubClients.dataOwner.identifier}
                        </TwTable.BodyCol>
                      </TwTable.BodyRow>
                  </TwTable.Body>
                </TwTable>
              </>
            )}

            { renderClientList("Clients for current company", hubClients?.clients?.filter(c => c.groupId === oidcRoutesContext?.customerInfo?.customerId)) }
            { renderClientList("Clients for other companies", hubClients?.clients.filter(c => c.groupId !== oidcRoutesContext?.customerInfo?.customerId)) }

            <div className='flex flex-row mt-10 text-black dark:text-gray-200'>
              <h3 className="font-semibold leading-6 text-2xl flex">
              Unmapped servers
              </h3>
              <p className='mt-1 ml-2 text-sm'>({unmappedServers?.length || 0})</p>
            </div>
            {loadingSrvData && (
              <div className='flex flex-wrap'>
                <CmpLabel text={"Loading servers..."} type={CmpLabel.types.loader} additionalClass='font-bold mt-4 w-full' />
              </div>
            )}
            {!loadingSrvData && (
              <TwTable additionalClass='mt-6'>
                <TwTable.Head>
                  <TwTable.Header additionalClass={'uppercase sm:pl-6'}>
                    Server Id
                  </TwTable.Header>
                  <TwTable.Header additionalClass={'uppercase sm:pl-6'}>
                    Server Name 
                  </TwTable.Header>
                  <TwTable.Header additionalClass={'uppercase sm:pl-6'}>
                    Template Group
                  </TwTable.Header>
                  <TwTable.Header additionalClass={'uppercase sm:pl-6'}>
                    Template Environment
                  </TwTable.Header>
                </TwTable.Head>
                <TwTable.Body>
                  { unmappedServers && unmappedServers.map((srvData) => (
                    <TwTable.BodyRow key={srvData.srv.serverId}>
                      <TwTable.BodyCol additionalClass={'font-medium'}>
                        {srvData.srv.serverId}
                      </TwTable.BodyCol>
                      <TwTable.BodyCol>
                        {srvData.srv.name}
                      </TwTable.BodyCol>
                      <TwTable.BodyCol>
                        {srvData.envGrpId}
                      </TwTable.BodyCol>
                      <TwTable.BodyCol>
                        {truncateString(srvData.tpl.id, 26)}
                      </TwTable.BodyCol>
                    </TwTable.BodyRow>
                  ))}
                </TwTable.Body>
              </TwTable>
            )}
          </>
        )}

      </TwPage>
    </>
  );
}
